<template>
  <swiper class="stories-main-slider"
          ref="storiesMainSlider"
          :slides-per-view="swiperOptions.slidesPerView"
          :centeredSlides="swiperOptions.centeredSlides"
          :initialSlide="swiperOptions.initialSlide"
          @swiper="setMainSlider"
          @slideChange="onSlideChange"
          @touchStart="onTouchStart"
          @touchEnd="onTouchEnd"
  >

    <swiper-slide
        class="stories-main-slider__item"
        v-for="(story, i) in stories"
        :key="i"
        @click="slideTo(i, speed)"
    >

      <m-a :href="findLinkOnContent(story.abstraction)" target="_blank">
        <StoriesGroupSlider
            :mainStory="story"
            @swiper="setGroupSlider"
            @slideChange="onSlideChange"
        />
      </m-a>


      <button
          class="close-btn stories-main-slider__item-btn"
          @click="closeStory"
      >
        <i class="bi bi-x"></i>
      </button>

    </swiper-slide>

    <div class="stories-main-slider__nav"
         v-if="hideButtonOnMobile"
         @touchstart="onTouchStart"
         @touchend="onTouchEnd"
    >
      <button
          class="stories-main-slider__nav-prev"
          v-show="isPrevBtnHidden"
          @click="slideNext()"
      >
        <icon-chevron-right/>
      </button>
      <button
          class="stories-main-slider__nav-next"
          v-show="isNextBtnHidden"
          @click="slidePrev()"
      >
        <icon-chevron-right/>
      </button>
    </div>

    <!--    <button
            class="close-btn stories-main-slider__btn"
            @click="closeStory"
        >
          <icon-close/>
        </button>-->

  </swiper>
</template>

<script setup>
import {ref, computed} from 'vue';
import {Swiper, SwiperSlide} from 'swiper/vue';
import IconClose from '../Icon/IconClose.vue';
import IconChevronRight from '../Icon/IconChevronRight.vue';
import {defineProps, defineEmits} from "vue";
import StoriesGroupSlider from '../Group/StoriesGroupSlider.vue';
import 'swiper/css';
import mA from '../../../../Tags/A.vue'

const props = defineProps(['stories', 'storyIndex']);
const stories = props.stories;
const mainSlider = ref(null);
const groupSlider = ref(null);
const autoplayDelay = ref(5000);
const speed = ref(500);
const isPaused = ref(false);
let interval = ref(null);
const storiesMainSlider = ref(null);
const emit = defineEmits(['close'])

const activeSlide = computed(() => {
  return mainSlider.value?.slides[activeIndex.value];
});

const sliderGroup = computed(() => {
  return activeSlide.value.querySelector('.stories-group-slider');
});

const activeIndex = computed(() => {
  return mainSlider.value?.activeIndex;
});

const setActiveIndex = () => {
  stories.storyIndex = activeIndex.value;
};

const hideButtonOnMobile = computed(() => {
  return window.innerWidth > 786;
})

const setMainSlider = (swiper) => {
  mainSlider.value = swiper;
  setProgress();
  slideTo(props.storyIndex);
};

const setGroupSlider = (swiper) => {
  groupSlider.value = swiper;
};

const swiperOptions = ref({
  slidesPerView: 'auto',
  centeredSlides: true,
});

const closeStory = () => {
  stopProgress();
  emit('close', {index: null, selectedStory: false})
};

const slideNext = () => {
  if (!sliderGroup.value.swiper.isEnd) {
    sliderGroup.value.swiper.slideNext(speed.value);
    return;
  }
  mainSlider.value.slideNext();
};

const slidePrev = () => {
  if (!sliderGroup.value.swiper.isBeginning) {
    sliderGroup.value.swiper.slidePrev(speed.value);
    return;
  }
  mainSlider.value.slidePrev();
};

const isPrevBtnHidden = computed(() => {
  if (mainSlider.value) {
    if (sliderGroup.value.swiper.isBeginning && mainSlider.value.isBeginning) {
      return false;
    }
    return true;
  }
});

const isNextBtnHidden = computed(() => {
  if (mainSlider.value) {
    if (sliderGroup.value.swiper.isEnd && mainSlider.value.isEnd) {
      return false;
    }
    return true;
  }
});

const slideTo = (i, speed = 0) => {
  mainSlider.value.slideTo(i, speed);
};

const setProgress = () => {
  const bullets = sliderGroup.value.querySelectorAll('.swiper-pagination-bullet');
  const time = autoplayDelay.value / 100;

  bullets.forEach((bullet, index) => {
    const span = bullet.querySelector('span');
    span.style.transform = 'translateX(-100%)';

    if (index === sliderGroup.value.swiper.activeIndex) {
      let transform = -100;

      interval.value = setInterval(() => {

        transform < 0 && !isPaused.value ? transform += 1 : false;
        span.style.transform = `translateX(${transform}%)`;

        if (sliderGroup.value.swiper.isEnd && transform === 0) {
          stopProgress();

          mainSlider.value.isEnd ? closeStory() : false;
          mainSlider.value.slideNext(speed.value);

        } else if (transform === 0) {
          sliderGroup.value.swiper.slideNext(speed.value);
        }

      }, time);

    } else if (index < sliderGroup.value.swiper.activeIndex) {
      span.style.transform = `translateX(0%)`;
    }

  });

};

const stopProgress = () => {
  clearInterval(interval.value);
};

const onSlideChange = () => {
  mainSlider.value ? (stopProgress(), setProgress()) : false;
  setActiveIndex();
};

const onTouchStart = () => {
  isPaused.value = true;
};

const onTouchEnd = () => {
  isPaused.value = false;
};

defineExpose({
  closeStory
});

</script>

<style scoped>
.stories-main-slider {
  overflow: visible;
  width: 100%;
}

.stories-main-slider__item {
  margin: 0 10vw;
  width: 40rem;
  height: 60rem;
  border-radius: 1.6rem;
  transform: scale(0.6);
  transition: transform 0.3s ease;
  position: relative;
}

.stories-main-slider__item.swiper-slide-prev, .stories-main-slider__item.swiper-slide-next {
  cursor: pointer;
}

.stories-main-slider__item.swiper-slide-prev:hover {
  transform: scale(0.6) translate(20%);
}

.stories-main-slider__item.swiper-slide-next:hover {
  transform: scale(0.6) translate(-20%);
}

@media only screen and (max-width: 991px) {
  .stories-main-slider__item {
    margin: 0 5vw;
    width: 50rem;
    height: 78rem;
    transform: scale(0.8);
  }
}

@media only screen and (max-width: 767px) {
  .stories-main-slider__item {
    margin: 0;
    width: 100vw;
    height: 100vh;
    border-radius: 0;
  }
}

.stories-main-slider__item.swiper-slide-active {
  transform: scale(1);
}

.stories-main-slider__item.swiper-slide-active :deep(.stories-group-slider__pagination) {
  opacity: 1;
  visibility: visible;
}

.stories-main-slider__item.swiper-slide-active .stories-main-slider__item-btn {
  opacity: 1;
  visibility: visible;
}

.stories-main-slider__item-btn {
  position: absolute;
  top: 8rem;
  right: 2rem;
  width: 3rem;
  height: 3rem;
  opacity: 0;
  visibility: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 35px;
}

.stories-main-slider__item-btn :deep(svg) {
  width: 3rem;
  height: 3rem;
  max-width: 100%;
  max-height: 100%;
}

@media (min-width: 320px) and (max-width: 767px) {
  .stories-main-slider__item-btn {
    top: 4rem
  }
}

@media (min-width: 768px) and (max-width: 992px) {
  .stories-main-slider__item-btn {
    top: 14rem
  }
}

@media only screen and (min-width: 993px) {
  .stories-main-slider__item-btn {
    top: 17rem
  }
}

/*@media only screen and (min-width: 825px) {
  .stories-main-slider__item-btn {
    top: 10rem
  }
}

@media only screen and (min-width: 1024px) {
  .stories-main-slider__item-btn {
    top: 9rem
  }
}*/


.stories-main-slider__nav {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 55rem;
  z-index: 100;
}

@media only screen and (max-width: 991px) {
  .stories-main-slider__nav {
    width: 68rem;
  }
}

@media only screen and (max-width: 767px) {
  .stories-main-slider__nav {
    width: 100%;
    height: 100%;
  }
}

.stories-main-slider__nav-prev, .stories-main-slider__nav-next {
  padding: 0.5rem;
  width: 5rem;
  height: 5rem;
  background-color: #fff;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  transition: background-color 0.3s ease;
}

@media only screen and (min-width: 768px) {
  .stories-main-slider__nav-prev:hover, .stories-main-slider__nav-next:hover {
    background-color: #e8e8e8;
  }
}

.stories-main-slider__nav-prev :deep(svg), .stories-main-slider__nav-next :deep(svg) {
  width: 2.5rem;
  height: 2.5rem;
  max-width: 100%;
  max-height: 100%;
}

.stories-main-slider__nav-prev, .stories-main-slider__nav-next, .stories-main-slider__nav-prev:focus, .stories-main-slider__nav-next:focus {
  border: none;
  outline: none;
}

@media only screen and (max-width: 767px) {
  .stories-main-slider__nav-prev, .stories-main-slider__nav-next {
    display: none;
  }
}

@media only screen and (max-width: 767px) {
  .stories-main-slider__nav-prev, .stories-main-slider__nav-next {
    width: 50%;
    height: 100%;
    background: transparent;
  }
}

.stories-main-slider__nav-prev {
  left: 0;
  transform: rotate(180deg);
}

.stories-main-slider__nav-next {
  right: 0;
}

.stories-main-slider__btn {
  display: none;
}

.stories-main-slider__btn :deep(svg) {
  font-size: 15px !important;
}

@media only screen and (max-width: 767px) {
  .stories-main-slider__btn {
    position: absolute;
    display: flex;
    top: 7.2rem;
    right: 0.7rem;
    width: 4rem;
    height: 4rem;
    z-index: 200;
  }

  .stories-main-slider__btn :deep(svg) {
    width: 6rem;
    height: 6rem;
    max-width: 100%;
    max-height: 100%;
  }
}

.close-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  border-radius: 50%;
  transition: opacity 0.3s ease;
  border: none;
  z-index: 1;
  font-family: 'Arial' !important;
}

.close-btn :deep(svg) {
  width: 100%;
  height: 100%;
  font-family: 'Arial' !important;
}

</style>